import { render, staticRenderFns } from "./Recebidas.vue?vue&type=template&id=06559c86&"
import script from "./Recebidas.vue?vue&type=script&lang=js&"
export * from "./Recebidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports